import { memo } from "react";
import { useMsal } from "@azure/msal-react";
import Icon from "../../../Elements/Icon/Icon";
import Tooltip from "../../../Elements/Tooltip/Tooltip";
import type { IPublicClientApplication } from "@azure/msal-browser";

const isLocalHost = window.location.origin.includes("3000");
interface MicrosoftLoginButtonI {
  handleApiAuth: (body: any) => void;
}

const MicrosoftLoginButton = memo(
  ({ handleApiAuth }: MicrosoftLoginButtonI) => {
    const { instance } = useMsal();

    const handleClick = async (instance: IPublicClientApplication) => {
      if (isLocalHost) {
        alert('Microsoft SSO works with HTTPS only');
        return;
      }

      const result = await instance.loginPopup({
        scopes: ["User.Read openid profile"]
      });
      if (result) {
        const body = {
          OAuthProvider: "microsoft",
          OAuthAccessToken: result?.accessToken,
          Url: window.location.pathname + window.location.search,
        };
        handleApiAuth(body);
      }
    };

    return (
      //@ts-ignore
      <Tooltip
        id="googleLoginButton"
        tooltipTextKey="microsoft-login-tooltip-text"
      >
        <div className="microsoft-login-button" onClick={() => handleClick(instance)}>
          <Icon name="microsoft" ext="png" />
          <span>Microsoft</span>
        </div>
      </Tooltip>
    );
  }
);

export default MicrosoftLoginButton;
